import { DEVELOPMENT } from "../../constants"

export const MIN_LENGTH = DEVELOPMENT ? 0 : 10
export const INSTRUCTOR_WIDTH = 40
export const NORMAL_WIDTH = 32
export const PROGRESS_THICKNESS = 3
